import { render, staticRenderFns } from "./estorno.vue?vue&type=template&id=255ba922"
import script from "./estorno.ts?vue&type=script&lang=js&external"
export * from "./estorno.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255ba922')) {
      api.createRecord('255ba922', component.options)
    } else {
      api.reload('255ba922', component.options)
    }
    module.hot.accept("./estorno.vue?vue&type=template&id=255ba922", function () {
      api.rerender('255ba922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/estorno.vue"
export default component.exports